import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from "@/components/ui/alert-dialog";
import { AlertTriangle, Mail } from "lucide-react";

interface GiftCardDuplicateWarningModalProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  onConfirm: () => void;
  isLoading?: boolean;
}

const GiftCardDuplicateWarningModal = ({
  open,
  onOpenChange,
  onConfirm,
  isLoading = false,
}: GiftCardDuplicateWarningModalProps) => {
  return (
    <AlertDialog open={open} onOpenChange={onOpenChange}>
      <AlertDialogContent className="max-w-lg">
        <AlertDialogHeader>
          <AlertDialogTitle className="flex items-center gap-2 font-playfair text-xl">
            <AlertTriangle className="h-5 w-5 text-amber-500" />
            Vous avez déjà commandé un bon cadeau aujourd'hui
          </AlertDialogTitle>
          <AlertDialogDescription asChild>
            <div className="space-y-3 text-sm text-muted-foreground pt-2">
              <p>
                J'ai bien enregistré une commande de bon cadeau aujourd'hui à cette adresse email.
                Si vous n'avez pas reçu votre email de confirmation, voici quelques pistes&nbsp;:
              </p>
              <div className="bg-bbz-beige/40 border border-bbz-beige rounded-md p-3 space-y-2">
                <div className="flex gap-2">
                  <Mail className="h-4 w-4 mt-0.5 flex-shrink-0 text-bbz-green-dark" />
                  <p>
                    Vérifiez votre dossier <strong>Spams / Courriers indésirables</strong>.
                    L'email peut s'y trouver.
                  </p>
                </div>
                <div className="flex gap-2">
                  <Mail className="h-4 w-4 mt-0.5 flex-shrink-0 text-bbz-green-dark" />
                  <p>
                    Pensez à marquer l'expéditeur{" "}
                    <strong>contact@biobeautezen.com</strong> comme fiable
                    pour les prochains envois.
                  </p>
                </div>
              </div>
              <p>
                Si vous ne trouvez vraiment rien, n'hésitez pas à me contacter directement
                avant d'effectuer un nouvel achat — je vous renverrai votre bon avec plaisir.
              </p>
              <p className="font-medium text-bbz-text">
                Souhaitez-vous tout de même commander un second bon cadeau&nbsp;?
              </p>
            </div>
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel disabled={isLoading}>Annuler</AlertDialogCancel>
          <AlertDialogAction
            onClick={(e) => {
              e.preventDefault();
              onConfirm();
            }}
            disabled={isLoading}
            className="bg-bbz-green-dark hover:bg-bbz-green-dark/90"
          >
            {isLoading ? "Redirection..." : "Oui, commander un second bon"}
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
};

export default GiftCardDuplicateWarningModal;
